"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigType = void 0;
/**
 * Enum to identify an I18n Configuration.
 * All available configurations will be registered here.
 */
class ConfigType {
    constructor(_name, _parent) {
        this._name = _name;
        this._parent = _parent;
    }
    /**
     * Returns the parent of the {@link ConfigType} enum,
     * or undefined if no parent exists.
     */
    get parent() {
        return this._parent;
    }
    toString() {
        return this._name;
    }
}
exports.ConfigType = ConfigType;
/**
 * Reads the mapping from MarketplaceID to CX Tuple.
 */
ConfigType.MARKETPLACEID_TO_CX_TUPLE = new ConfigType('MARKETPLACEID_TO_CX_TUPLE');
/**
 * Reads Price Format related configurations used in IU libraries.
 * This is the base for all Price Format type configurations.
 */
ConfigType.PRICE_FORMAT = new ConfigType('PRICE_FORMAT');
/**
 * Reads Price Format related configurations used in IU libraries.
 * This setting applies configs specifically to cx-family retail.
 * It is a sub-type of PRICE_FORMAT.
 */
ConfigType.RETAIL_PRICE_FORMAT = new ConfigType('RETAIL_PRICE_FORMAT', ConfigType.PRICE_FORMAT);
/**
* Reads Points Format related configurations used in IU libraries.
*/
ConfigType.POINTS_FORMAT = new ConfigType('POINTS_FORMAT');
/**
 * Reads the mapping from CXTuple to equivalent I18nDomain.
 */
ConfigType.CX_TUPLE_TO_I18N_DOMAIN = new ConfigType('CX_TUPLE_TO_I18N_DOMAIN');
/**
 * Reads the mapping from CXTuple to corresponding default languages and currencies.
 */
ConfigType.CX_TUPLE_TO_DEFAULT_PREFERENCES = new ConfigType('CX_TUPLE_TO_DEFAULT_PREFERENCES');
//# sourceMappingURL=config-type.js.map